//
import Service from '@/services/api/service'
import PurchaseQuotationModel from '@/models/Purchase/PchPurchaseQuotation'

/**
 * This class describes a pch purchase quotation.
 *
 * @class      PchPurchaseQuotation (name)
 */
export default class PchPurchaseQuotation extends Service {

  /**
   * Return the pch purchase quotation resource.
   *
   * @return     {Object}  The pch purchase quotation model
   */
  resource() {
    return PurchaseQuotationModel
  }

  /**
   * Returns a pch purchase quotation list.
   *
   * @return     {Object}  The pch purchase quotation list request.
   */
  toList() {
    return this
      .append('')
      .include(
        'g_user.hr_employee',
        //'g_branch_office',
        'pch_detail_purchase_quotations',
        //'pch_detail_purchase_quotations.wh_product',
        'pch_detail_providers_purchase_quotations.pch_provider',
        //'pch_detail_providers_purchase_quotations.pch_provider_branch_offices',
      )
  }
}
